module.exports = __webpack_public_path__ + "img/location-text-img_540.cb552c20.jpg";